/* eslint-disable max-len */
/* eslint-disable max-lines */
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Button, Card, Label, Popup} from 'semantic-ui-react';
import {handleExcelFlInventory} from '../../utils/commonUtils';
import {Link} from 'react-router-dom';
import {advanceReserveList} from '../../constants/advanceReserveListDivided';
import {daysDepositList} from '../../constants/daysDepositList';


const vehiclesMapper = {
  'transitNotAvailable': 'TRÁNSITO / NO DISPONIBLES',
  'transitDeposit': 'DEPÓSITO',
  'transitTotal': 'TRÁNSITO',
  'transitFree': 'TRÁNSITO / LIBRES',
  'transitReservations': 'TRÁNSITO / RESERVADAS',
  'depositNotAvailable': 'DEPÓSITO / DISPONIBLES',
  'depositFree': 'DEPÓSITO / LIBRES',
  'depositReservations': 'DEPÓSITO / RESERVADAS',
  'depositTotal': 'DEPÓSITO',
  'depositSolNac': 'DEPÓSITO / SOL. NAC.',
};

const generateFiltersNames = ({group, master, sfx, dealer, reservationAdvance, antiquity}, vehiclesData, dealers) => {
  const listNames = [];
  if (group) {
    listNames.push(vehiclesMapper[group]);
  }
  if (master) {
    listNames.push((vehiclesData || []).find((veh) => (veh?.original.katashiki === master && veh?.original.sfx === sfx))?.original.description);
  }
  if (dealer) {
    listNames.push((dealers || []).find((dlr) => dlr?.identification === dealer)?.name);
  }
  if (antiquity) {
    listNames.push(`${daysDepositList.find((dy) => dy?.key === antiquity)?.text} DÍAS`);
  }
  if (reservationAdvance) {
    listNames.push(advanceReserveList.find((adv) => adv?.key === reservationAdvance)?.text);
  }
  return listNames;
};

const Header = ({
  filteredRows,
  setResetAllFilters,
  listDealers,
  filters,
  dealerId,
  isUserTde,
}) => {
  const handleExportExcel = () => {
    const excelRows = filteredRows.map((row) => {
      return row.original;
    });
    handleExcelFlInventory(excelRows, {dealerId, isUserTde});
  };
  const handleCleanFilters = () => {
    setResetAllFilters(true);
  };
  const [filtersNames, setFiltersNames] = useState([]);
  useEffect(() => {
    setFiltersNames(generateFiltersNames(filters, filteredRows, listDealers));
  }, [filteredRows, listDealers]);

  return (
    <Card fluid>
      <div className="title-bar center-vertical">
        <div className="title center-vertical">
          <h2>
            Administración de inventario flotante
          </h2>
          <div className={'floating-chip-info'}>
            {'Total:'}
            <Label.Detail>{filteredRows?.length}</Label.Detail>
            <Popup
              trigger={
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-funnel-fill ml" viewBox="0 0 16 16">
                  <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/>
                </svg>
              }
              position="bottom center"
              size="small"
              inverted
            >
              <Popup.Content style={{'fontSize': '9px'}}>
                <div className='floating-filters-chip-content'>
                  Filtros previos:
                  {filtersNames.map((fltr) => <div className={'floating-chip-data'} >{fltr}</div>)}
                </div>
              </Popup.Content>
            </Popup>
          </div>
          <div className="title-bar-actions">
            <Link to="/vehiculos/inventario-flotante-resumen">
              <Button type="button" basic className="toyota-secondary">
                VOLVER
              </Button>
            </Link>
            <Button basic onClick={handleCleanFilters}>LIMPIAR FILTROS</Button>
            <Button primary color='red' onClick={handleExportExcel}>EXPORTAR</Button>
          </div>
        </div>
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    'listDealers': state.dealer.list,
    'dealerId': state.session.dealerId,
    'isUserTde': state.session.isUserFromTDE,
  };
};

export default connect(mapStateToProps, {})(Header);
